import soundService from '@/services/SoundService'

const state = {
  bgm: null
}

const mutations = {
  SET_BGM(state, payload) {
    state.bgm = payload
  }
}

const actions = {
  playBGM({ state, commit }, value) {
    if (value === state.bgm) return
    if (value) commit('SET_BGM', value)
    soundService.stopAll('bgm')
    soundService.bgmPlay(state.bgm)
  },
  stopBGM({ commit }) {
    soundService.stopAll('bgm')
    commit('SET_BGM', null)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
